(() => {
  const config = window.GA4_ECOMMERCE || {};
  const CURRENCY = config.currency || 'EUR';
  const AFFILIATION = config.affiliation || 'Lumiere Epoque Online Store';
  const VERTICAL = config.googleBusinessVertical || 'retail';
  const GTM_ID = config.gtmId;

  let gtmLoaded = false;
  let trackingReady = false;

  window.dataLayer = window.dataLayer || [];

  function formatPriceFromCents(cents) {
    const amount = Number(cents);
    if (Number.isNaN(amount)) return '0.00';
    return (amount / 100).toFixed(2);
  }

  function clearEcommerce() {
    window.dataLayer.push({ ecommerce: null });
  }

  function pushEvent(eventName, ecommerce) {
    if (!trackingReady && !config.designMode) return;
    clearEcommerce();
    window.dataLayer.push({
      event: eventName,
      ecommerce: {
        ...ecommerce,
        currency: ecommerce.currency || CURRENCY,
      },
    });
  }

  function normalizeItem(raw) {
    if (!raw || typeof raw !== 'object') return null;

    const itemId = String(raw.item_id || raw.id || '');
    const price = raw.price || formatPriceFromCents(raw.price_cents);

    return {
      item_name: raw.item_name || '',
      item_id: itemId,
      id: itemId,
      price,
      item_brand: raw.item_brand || '',
      item_category: raw.item_category || '',
      item_category2: raw.item_category2 || '',
      item_variant: raw.item_variant || '',
      item_list_name: raw.item_list_name || '',
      item_list_id: raw.item_list_id || '',
      index: Number(raw.index) || 1,
      quantity: String(raw.quantity ?? '1'),
      google_business_vertical: raw.google_business_vertical || VERTICAL,
    };
  }

  function parseItemFromElement(element) {
    if (!element) return null;

    const jsonEl = element.querySelector('[data-ga4-item-json]');
    if (jsonEl) {
      try {
        return normalizeItem(JSON.parse(jsonEl.textContent));
      } catch (e) {
        console.warn('GA4: invalid item JSON', e);
      }
    }

    const attr = element.getAttribute('data-ga4-item');
    if (attr) {
      try {
        return normalizeItem(JSON.parse(attr));
      } catch (e) {
        console.warn('GA4: invalid data-ga4-item', e);
      }
    }

    return null;
  }

  function itemsFromElements(elements) {
    return [...elements]
      .map((el) => parseItemFromElement(el))
      .filter(Boolean);
  }

  function sumItemPrices(items) {
    return items
      .reduce((total, item) => total + Number(item.price || 0), 0)
      .toFixed(2);
  }

  function loadGtm() {
    if (gtmLoaded || !GTM_ID || config.designMode) return;
    gtmLoaded = true;

    window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
    document.head.appendChild(script);
  }

  function enableTracking() {
    if (trackingReady) return;
    trackingReady = true;
    loadGtm();
    document.dispatchEvent(new CustomEvent('ga4:ready'));
  }

  function initTracking() {
    if (config.designMode) return;
    enableTracking();
  }

  window.GA4 = {
    get ready() {
      return trackingReady;
    },
    formatPriceFromCents,
    normalizeItem,
    parseItemFromElement,
    itemsFromElements,
    sumItemPrices,
    clearEcommerce,
    pushEvent,
    affiliation: AFFILIATION,
    currency: CURRENCY,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTracking);
  } else {
    initTracking();
  }
})();
